import { BOLD_FONT_WEIGHT, BORDER_COLOR, DEFAULT_FONT_SIZE, HOVER_BACKGROUND, ICON_COLOR, INPUT_BACKGROUND, MEDIUM_FONT_WEIGHT, REGULAR_FONT_WEIGHT, TEXT_COLOUR } from '@app/shared/primeng/config/primeng-constants';
import { ComponentsDesignTokens } from '@primeuix/themes/types';

export const primeNgComponents: ComponentsDesignTokens = {
	autocomplete: {
		root: {
			paddingX: '1rem',
			paddingY: '1rem'
		},
		option: {
			padding: '1rem'
		},
		optionGroup: {
			fontWeight: 'unset'
		}
	},
	badge: {
		colorScheme: {
			light: {
				primary: {
					background: '#dbdbdb',
					color: '{text.color}'
				}
			}
		}
	},
	button: {
		colorScheme: {
			light: {
				text: {
					plain: {
						color: 'rgba(0, 0, 0, 0.60)',
						hoverBackground: HOVER_BACKGROUND
					},
					success: {
						hoverBackground: 'color-mix(in srgb, var(--color-positive) 4%, transparent)',
						activeBackground: 'color-mix(in srgb, var(--color-positive) 16%, transparent)',
						color: 'var(--color-positive)'
					},
					danger: {
						hoverBackground: 'color-mix(in srgb, var(--color-negative) 4%, transparent)',
						activeBackground: 'color-mix(in srgb, var(--color-negative) 16%, transparent)',
						color: 'var(--color-negative)'
					}
				}
			}
		},
		root: {
			label: {
				fontWeight: MEDIUM_FONT_WEIGHT
			},
			lg: {
				paddingX: '1.32rem',
				paddingY: '0.825rem'
			}
		}
	},
	checkbox: {
		root: {
			filledBackground: '#fff',
			borderColor: '#757575',
			hoverBorderColor: '#757575'
		}
	},
	datatable: {
		headerCell: {
			focusRing: {
				shadow: 'none',
				width: '1px',
				style: 'solid',
				color: 'rgba(0, 0, 0, 0.60)'
			}
		}
	},
	datepicker: {
		weekDay: {
			color: 'rgba(0, 0, 0, 0.80)',
			fontWeight: MEDIUM_FONT_WEIGHT
		},
		inputIcon: {
			color: ICON_COLOR
		}
	},
	dialogservice: {
		button: {
			fontWeight: MEDIUM_FONT_WEIGHT
		}
	},
	dialog: {
		css: () => `
			.p-dialog {
				border: 0;
			}
			.p-dialog-content {
				flex-grow: 1;
			}
			.p-dialog-footer {
			    flex-wrap: wrap;
			}
		`,
		content: {},
		header: {
			padding: '1rem 1.5rem'
		},
		footer: {
			padding: '1rem 1.5rem'
		}
	},
	drawer: {
		content: {
			padding: '0 1rem 1rem 1rem'
		},
		header: {
			padding: '1rem'
		}
	},
	floatlabel: {
		root: {
			color: 'rgba(0, 0, 0, 0.60)',
			fontWeight: REGULAR_FONT_WEIGHT
		}
	},
	inputtext: {
		root: {
			paddingX: '1rem',
			paddingY: '1rem',
			disabledBackground: INPUT_BACKGROUND
		}
	},
	listbox: {
		option: {
			padding: '1rem'
		},
		colorScheme: {
			light: {
				option: {
					color: TEXT_COLOUR
				}
			}
		},
		root: {
			color: TEXT_COLOUR,
			borderColor: BORDER_COLOR
		}
	},
	menu: {
		item: {
			padding: '1rem',
			icon: {
				color: ICON_COLOR
			}
		},
		submenuLabel: {
			fontWeight: REGULAR_FONT_WEIGHT,
			color: 'rgba(0, 0, 0, 0.60)'
		},
		css: () => `.p-menu-item-label { transform: translateY(1px); white-space: nowrap; }`
	},
	menubar: {
		root: {
			background: 'transparent'
		},
		item: {
			padding: '1rem'
		}
	},
	message: {
		colorScheme: {
			light: {
				success: {
					background: '#c8e6c9',
					color: '#1b5e20'
				},
				info: {
					background: '#b3e5fc',
					color: '#01579b'
				},
				warn: {
					background: '#ffecb3',
					color: '#7f6003'
				},
				error: {
					background: '#ffcdd2',
					color: '#b71c1c'
				}
			}
		},
		text: {
			fontWeight: REGULAR_FONT_WEIGHT
		},
		content: {
			padding: '1.25rem 1.5rem'
		}
	},
	multiselect: {
		root: {
			paddingX: '1rem',
			paddingY: '1rem',
		},
		option: {
			padding: '1rem'
		}
	},
	paginator: {
		root: {
			background: 'transparent',
			padding: '0.5rem 0'
		},
		navButton: {
			color: 'rgba(0, 0, 0, 0.60)'
		}
	},
	radiobutton: {
		root: {
			filledBackground: '#fff',
			borderColor: '#757575',
			hoverBorderColor: '#757575'
		}
	},
	select: {
		root: {
			paddingX: '1rem',
			paddingY: '1rem',
		},
		list: {
			header: {
				padding: '0'
			},
			padding: '0'
		}
	},
	slider: {
		track: {
			size: '3px'
		},
		handle: {
			content: {
				background: '#fff',
				hoverBackground: '#fff'
			}
		}
	},
	tabs: {
		tablist: {
			background: 'transparent'
		},
		tabpanel: {
			padding: '1.5rem 0'
		},
		tab: {
			color: 'rgba(0, 0, 0, 0.60)',
			fontWeight: MEDIUM_FONT_WEIGHT,
			hoverBackground: HOVER_BACKGROUND
		}
	},
	tieredmenu: {
		item: {
			padding: '1rem',
			icon: {
				color: ICON_COLOR
			}
		}
	},
	toast: {
		summary: {
			fontSize: DEFAULT_FONT_SIZE,
			fontWeight: BOLD_FONT_WEIGHT
		},
		detail: {
			fontSize: DEFAULT_FONT_SIZE,
			fontWeight: REGULAR_FONT_WEIGHT
		},
		colorScheme: {
			light: {
				success: {
					background: '#c8e6c9',
					color: '#1b5e20',
					borderColor: '#c8e6c9',
					detailColor: '#1b5e20'
				},
				info: {
					background: '#b3e5fc',
					color: '#01579b',
					borderColor: '#b3e5fc',
					detailColor: '#01579b'
				},
				warn: {
					background: '#ffecb3',
					color: '#7f6003',
					borderColor: '#ffecb3',
					detailColor: '#7f6003'
				},
				error: {
					background: '#ffcdd2',
					color: '#b71c1c',
					borderColor: '#ffcdd2',
					detailColor: '#b71c1c'
				}
			}
		}
	},
	tooltip: {
		css: () => `.p-tooltip-text { font-size: 13px; }`
	},
	tree: {
		css: () => `
			.p-tree-node-content.p-tree-node-dragover {
				background: color-mix(in srgb, var(--p-primary-color) 7%, transparent);
			}
		`,
		root: {
			gap: '0',
			transitionDuration: '0'
		},
		nodeToggleButton: {
			size: '2.5rem',
			hoverBackground: HOVER_BACKGROUND
		},
		node: {
			padding: '.5rem 1rem .5rem .5rem'
		}
	},
	treetable: {
		nodeToggleButton: {
			size: '2.5rem',
			hoverBackground: HOVER_BACKGROUND
		},
		bodyCell: {
			padding: '.5rem 1rem .5rem .5rem'
		},
		css: () => `.p-treetable-toggler { margin-right: .5rem; } .p-treetable-wrapper { overflow: auto; }`
	}
};